<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="visibleSettings"
      :search="search"
      :loading="isLoading"
      :sort-by="['name']"
      group-by="groupName"
      no-data-text="No settings found."
      hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <div>
              Settings
            </div>
            <div class="grey--text caption">
              Changes are saved automatically.
            </div>
          </v-toolbar-title>
          <v-row justify="end">
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              placeholder="Search"
              append-icon="mdi-magnify"
              style="max-width: 200px;"
              class="pt-6"
            >
            </v-text-field>
          </v-row>
        </v-toolbar>
      </template>
      <template v-slot:group.header="{ group, headers }">
        <td :colspan="headers.length">
          <strong>{{ group }}</strong>
        </td>
      </template>
      <template v-slot:item.description="{ item }">
        <!-- // eslint-disable-next-line vue/no-v-html -->
        <div v-html="renderDescription(item.description)"></div>
      </template>
      <template v-slot:item.value="{ item }">
        <SettingEditor
          :setting="item"
          :dev="false"
          @change="onValueChange"
        ></SettingEditor>
      </template>
      <template v-if="isDeveloper" v-slot:item.devValue="{ item }">
        <SettingEditor
          :setting="item"
          :dev="true"
          @change="onValueChange"
        ></SettingEditor>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import Logger from "@/services/Logger";
import store from "@/store/store";
import { mapActions, mapGetters } from "vuex";
import SettingEditor from "@/components/SettingEditor";

export default {
  name: "Settings",
  components: {
    SettingEditor,
  },
  data: () => ({
    search: "",
    isLoading: false,
    headers: [
      { text: "Name", value: "name", width: "15%" },
      { text: "Description", value: "description", width: "30%" },
      { text: "Value", value: "value", width: "15%" },
      { text: "Dev. Value", value: "devValue", width: "15%" },
    ],
  }),
  computed: {
    accountOptInEmailAddress() {
      return process.env.VUE_APP_ACCOUNT_OPT_IN_EMAIL_ADDRESS;
    },
    ...mapGetters("settings", ["visibleSettings"]),
    ...mapGetters("auth", ["isDeveloper"]),
  },
  mounted() {
    if (!this.isDeveloper) {
      this.headers = this.headers.filter((h) => h.value !== "devValue");
    }
  },
  methods: {
    renderDescription(template) {
      return template.replace(
        "{{ accountOptInEmailAddress }}",
        this.accountOptInEmailAddress
      );
    },
    onValueChange(data) {
      this.updateSetting(data)
        .then(() => {
          this.showSnackbar({ message: "Setting saved!", type: "success" });
        })
        .catch((err) => {
          this.showSnackbar({ message: err.message, type: "error" });
        });
    },
    ...mapActions("settings", ["updateSetting"]),
    ...mapActions("snackbar", ["showSnackbar"]),
  },
  beforeRouteEnter(to, from, next) {
    const loadDataPromise = new Promise((resolve, reject) => {
      store
        .dispatch("settings/loadSettings")
        .then((settings) => {
          resolve(settings);
        })
        .catch((err) => {
          reject(err);
        });
    });

    next((vm) => {
      vm.isLoading = true;

      loadDataPromise
        .catch((err) => {
          Logger.error(err);
          store.dispatch("snackbar/showSnackbar", {
            message: err.message,
            color: "error",
          });
        })
        .finally(() => {
          vm.isLoading = false;
        });
    });
  },
};
</script>
